import { cx } from '@libs/classnames';

import { TournamentEntrance, TournamentMode } from '@features/shared/api/typings';
import { TOURNAMENT_MODES } from '@features/shared/constants';
import { OPEN_WITH_PRE_MODERATION_ENTRANCE } from '@features/tournament/ui/components/TournamentSettings/utils';

import styles from './EventEntrance.module.css';

const entrances: {
  [k in TournamentEntrance | typeof OPEN_WITH_PRE_MODERATION_ENTRANCE]: string;
} = {
  [OPEN_WITH_PRE_MODERATION_ENTRANCE]: 'Открытый\u00A0(модерация)',
  Open: 'Открытый',
  Rank: 'По\u00A0рейтингу',
  Invite: 'По\u00A0приглашению',
};

export type Props = {
  className?: string;
  tournament?: {
    mode: TournamentMode;
    entrance: TournamentEntrance;
    participantPreModerationEnabled?: boolean;
  };
  isManager?: boolean;
  customEntranceText?: string;
};

export function EventEntrance({ className, tournament, isManager, customEntranceText }: Props) {
  if (!tournament) return null;

  const mode = TOURNAMENT_MODES[tournament.mode];
  const entrance =
    customEntranceText ??
    (isManager && tournament.participantPreModerationEnabled
      ? entrances[OPEN_WITH_PRE_MODERATION_ENTRANCE]
      : entrances[tournament.entrance]);

  return (
    <span className={cx(className, styles.root)}>
      {mode} · {entrance}
    </span>
  );
}
